import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'

export const OperacionesCubicajeView = ({
  silo: { nombreCorto, fechaUltimoCubicaje, estado },
  openDialogNuevoCubicaje,
  openDialogModificarCubicaje,
  openDialogEliminarUltimoCubicaje,
  cancelar
}) => (
  <Grid container direction='column' justify='space-around' spacing={2} alignItems='center'>
    <Grid item xs={12}>
      <Typography variant='h6'>Operaciones de cubicaje disponibles para <strong>{nombreCorto}</strong></Typography>
    </Grid>
    {estado === 'U' && (
      <Grid item xs={12}>
        <Button
          variant='contained'
          onClick={openDialogNuevoCubicaje}>
          NUEVO CUBICAJE
        </Button>
      </Grid>
    )}
    {fechaUltimoCubicaje && estado === 'U' && (
      <>
        <Grid item xs={12}>
          <Button
            variant='contained'
            onClick={openDialogEliminarUltimoCubicaje}>
            ELIMINAR ULTIMO CUBICAJE
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant='contained'
            onClick={openDialogModificarCubicaje}>
            MODIFICAR ULTIMO CUBICAJE
          </Button>
        </Grid>
      </>
    )}
    <Grid container item spacing={2} justify='flex-end'>
      <Grid item xs='auto'>
        <Button
          color='primary'
          variant='contained'
          startIcon={<HighlightOffIcon />}
          onClick={cancelar}>
          Cerrar
        </Button>
      </Grid>
    </Grid>
  </Grid>
)
